
import {View} from 'backbone'
import template from "dashboard/connections/connection-operations-view.ejs";
import ConfirmationModal from 'dashboard/forms/modal/ConfirmationModal';
import {Model} from 'backbone';
import applyPermissionsToActions from '../../forms/modal/ApplyPermissionToActionsModal';
import util from 'util/Util.js';
class ConnectionOperationsView extends View{
    initialize(opts){
        this.template = template;
        this.connectionService = opts.connectionService;

        this.events = {
            'click input[name=applyChanges]': 'applyChanges',
            'click input[name=cancelChanges]': 'cancelChanges',
            'click input[name=migrate]': 'migrate',
            'click input[name=delete]': 'deleteConnection',
            'click input[name=newAction]': 'newAction'
        };


        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    applyChanges() {
        let connectionModel = this.connectionService.model.get('currentConnectionDetails');
        let containInvalidPermissions = false;

        if (connectionModel.PermissionsXML) {
            let permissionsArray = Array.isArray(connectionModel.PermissionsXML) ? connectionModel.PermissionsXML : [connectionModel.PermissionsXML];
            const invalidPermissions = permissionsArray.filter(conn => { return !conn.Permission || conn.Permission.length === 0; });
            containInvalidPermissions = invalidPermissions && invalidPermissions.length > 0;

            if (containInvalidPermissions) {
                const
                    confirmationTitle = 'Permission Warning',
                    confirmationText =
                        '<div class="row">' +
                        '  <div class="col-sm-1"><i class="pf-warning"></i></div>' +
                        '  <div class="col-sm-11">' +
                        '    <p> At least one of your users, positions or user-groups has no permission selected. ' +
                        'Applying changes will remove that role.</p>' +
                        '    <p>Are you sure you want to apply changes?</p>' +
                        '  </div>' +
                        '</div>';

                new ConfirmationModal({
                    model: new Model({
                        confirmationTitle: confirmationTitle,
                        confirmationText: confirmationText,
                        height: 220,
                        width: 500
                    })
                }).render().then(result => {
                    if (result === 'Yes') {
                        //remove invalid permissions
                        connectionModel.PermissionsXML = permissionsArray.filter(conn => { return conn.Permission && ((Array.isArray(conn.Permission) && conn.Permission.length > 0) || conn.Permission['@type']); });
                        this.connectionService.model.set('currentConnectionDetails', connectionModel, { silent: true });
                        this.applyPermissionsToActions();
                    }
                });
            }
        }
        if(!containInvalidPermissions){
            this.applyPermissionsToActions();
        }
      
        return;
    }

    applyPermissionsToActions(){
        
        let connectionModel = this.connectionService.model.get('currentConnectionDetails');
            connectionModel.permissionsToActions = "false";

            
        if (this.model.get("permissionsChanged")) {
            
            const applyPermissionsModal = new applyPermissionsToActions({ model: new Model() });
            applyPermissionsModal.settings.width = 400;
            
            applyPermissionsModal.render().then(result => {

                if (result !== "cancel") {
                    connectionModel.permissionsToActions = result;
                    this.connectionService.applyChanges.apply(this.connectionService, arguments);
                    this.model.unset('permissionsChanged', { silent: true });
                }
            });
        }
        else {
            this.connectionService.applyChanges.apply(this.connectionService, arguments);
        }
    }

    cancelChanges() {
        return this.connectionService.cancelChanges.apply(this.connectionService, arguments);
    }

    migrate(){
        return this.connectionService.migrate.apply(this.connectionService, arguments);
    }

    newAction(){
        return this.connectionService.newAction.apply(this.connectionService, arguments);
    }

    deleteConnection(){
        return this.connectionService.deleteConnection.apply(this.connectionService, arguments);
    }

    render(){
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }
}

export default ConnectionOperationsView;